import { render, staticRenderFns } from "./add-device-choose-brand.vue?vue&type=template&id=65fad604&scoped=true&"
import script from "./add-device-choose-brand.js?vue&type=script&lang=js&"
export * from "./add-device-choose-brand.js?vue&type=script&lang=js&"
import style0 from "./add-device-choose-brand.css?vue&type=style&index=0&id=65fad604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fad604",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VList,VListItem,VListItemAvatar,VListItemContent,VListItemGroup,VListItemTitle,VTextField})
